import { datadogRum } from "@datadog/browser-rum";

try {
    datadogRum.init({
        applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
        clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'us5.datadoghq.com',
        service: 'amac-react',
        env: 'Amacvoters',
        // Specify a version number to identify the deployed version of your application in Datadog
        version: '1.0.2',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        defaultPrivacyLevel: 'mask-user-input',
        trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
    });
    
    // Start tracking user sessions
    datadogRum.startSessionReplayRecording();
    } catch(e) {

    }



export default datadogRum;